import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6ovopeuyoa: FaireBrandEntity = {
  token: "b_6ovopeuyoa",
  type: "brand",
  name: "Namaste Jewelry",
  avatarUrl:
    "https://cdn.faire.com/fastly/d56339e9aff42ac4dec13a12f70503ff18d62e87a14c0d269b7e6fcdc949591b.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/9bc5ff45f4812734867913dd55800b9b4a05da75a25144a635f04d9224e35547.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d56339e9aff42ac4dec13a12f70503ff18d62e87a14c0d269b7e6fcdc949591b.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9bc5ff45f4812734867913dd55800b9b4a05da75a25144a635f04d9224e35547.jpeg",
  location: "Regina, SK, CAN",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 53,
  isTopShop: true,
  isInsider: false,
  description:
    "Pieces Inspired by the art of everyday life, Namaste creates luxury in simplicity. Our jewelry pieces are for the Modern Minimalists who love everything simple and chic.\n\nOur pieces are ethically designed and made in Canada with a few pieces/parts made in China and Bangladesh, where we work with small workshop owners to bring our designs to reality. We ensure they are socially responsible and do not involve child labor, pay fair wages, and a safe working environment.\n\nWe create our jewelry pieces using recycled metals and our hair accessories using eco-friendly cellulose acetate to reduce environmental impact. So join us on a journey of sustainable fashion, where style meets consciousness!\n\nEvery single order is hand-packed with love and care before we ship them off to you.\n\nMade by women, for everyone",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:02.054Z",
    importedBy: "entity-db-cli",
  },
};
